<template>
  <v-container id="create-orchestration-rule-form" fluid class="pt-0">
    <v-list-item class="pl-1 pr-0">
      <v-list-item-content class="mb-0">
        <v-text-field
          :disabled="!modificationEnabled"
          v-model="formRule.name"
          dense
          hide-details="auto"
          :label="$t('orderWorkflow.ruleName')"
        />
        <!-- <v-row class="mb-1 pr-1" justify="end"> -->

        <!-- </v-row>    -->
      </v-list-item-content>
      <v-list-item-action class="mb-0 ml-0">
        <v-btn text @click="minimized = !minimized" x-small color="secondary">
          <v-icon v-if="minimized">mdi-chevron-down</v-icon>
          <v-icon v-else>mdi-chevron-up</v-icon>
        </v-btn>
      </v-list-item-action>
    </v-list-item>
    <v-card outlined class="pt-0" v-show="!minimized">
      <v-container>
        <validation-observer ref="form">
          <v-form>
            <v-select
              v-model="formRule.stockSearchPriority"
              :items="stockSearchPriorities"
              :label="$t('orchestrationRule.stockPriority')"
              required
              :disabled="!modificationEnabled"
            ></v-select>
            <validation-provider
              v-if="filterOptions[formRule.stockSearchPriority]['mandatory'].includes('forcedLocations')"
              class="width-100"
              rules="required"
              :name="$t('orderWorkflow.forcedLocations')"
              v-slot="{ errors }"
            >
              <v-autocomplete
                v-model="formRule.forcedLocations"
                :items="stockPriorityLocations"
                :label="$t('orderWorkflow.forcedLocations')"
                clearable
                dense
                hide-details="auto"
                outlined
                multiple
                :disabled="!modificationEnabled"
                required
                :error-messages="errors"
              />
            </validation-provider>
            <validation-provider
              v-if="filterOptions[formRule.stockSearchPriority]['mandatory'].includes('predefinedLocationList')"
              tag="div"
              class="width-100"
              rules="required"
              :name="$t('orderWorkflow.predefinedLocationList')"
              v-slot="{ errors }"
            >
              <o-list-select
                v-model="formRule.predefinedLocationListId"
                :label="$t('orderWorkflow.locationList')"
                :disabled="!modificationEnabled"
                :items="lists"
                :loading="listsLoading"
                required
                :error-messages="errors"
                @create-list="onCreateList"
              />
            </validation-provider>
            <v-switch
              v-if="filterOptions[formRule.stockSearchPriority]['mandatory'].includes('forcePickupLocationAsSource')"
              v-model="formRule.forcePickupLocationAsSource"
              @change="forceSource()"
              :label="$t('orderWorkflow.forcePickupLocationAsSource')"
              :disabled="!modificationEnabled"
            />
            <v-switch
              v-if="filterOptions[formRule.stockSearchPriority]['mandatory'].includes('excludePickupLocationAsSource')"
              v-model="formRule.excludePickupLocationAsSource"
              @change="excludePickup()"
              :label="$t('orderWorkflow.excludePickupLocationAsSource')"
              :disabled="!modificationEnabled"
            />
            <!-- <v-row align="center" v-if="deliveryTypeFilterOption.length != 0">
              <v-col align="center" v-if="modificationEnabled">
                <v-btn
                  small
                  :disabled="unusedFilterOptions.length == 0"
                  class="ma-2"
                  color="primary"
                  outlined
                  @click="addFilter"
                  >{{ $t('orderWorkflow.addFilter') }}</v-btn
                >
              </v-col>
              <v-row v-else>
                <v-col class="text-center">
                  <v-card-text v-if="formRule.filters.length == 0" class="text-center">
                    {{ $t('orderWorkflow.noFilter') }}
                  </v-card-text>
                  <v-flex v-else-if="formRule.filters.length > 0">
                    <v-layout justify-center align-center>
                      <v-switch
                        class="d-flex justify-center"
                        :label="$t('orderWorkflow.displayFilters')"
                        v-model="showFilters"
                      ></v-switch>
                    </v-layout>
                  </v-flex>
                </v-col>
              </v-row>
            </v-row> -->
            <v-container>
              <!-- mandatory filters -->
              <v-row
                align="center"
                v-for="mandatoryFilters in filterOptions[formRule.stockSearchPriority]['mandatory']"
                v-bind:key="mandatoryFilters"
              >
                <validation-provider
                  v-if="mandatoryFilters === 'maximumResponseTime'"
                  class="width-100"
                  rules="min_value:1|integer|required"
                  name="maximum response times"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    v-model="formRule.maximumResponseTime"
                    type="number"
                    :min="1"
                    :error-messages="errors"
                    required
                    :suffix="$t('orderWorkflow.hours')"
                    :label="$t('orderWorkflow.maximumResponseTime')"
                    :disabled="!modificationEnabled"
                  >
                    <template v-slot:append-outer>
                      <v-tooltip v-model="showMaximumResponseTimeTooltip" top>
                        <template v-slot:activator="{ attrs }">
                          <v-btn
                            class="mt-1"
                            :disabled="!modificationEnabled"
                            x-small
                            icon
                            v-bind="attrs"
                            @click="showMaximumResponseTimeTooltip = !showMaximumResponseTimeTooltip"
                          >
                            <v-icon>mdi-information-outline</v-icon>
                          </v-btn>
                        </template>
                        <span>{{ $t('orderWorkflow.duringOpeningHours') }}</span>
                      </v-tooltip>
                    </template>
                  </v-text-field>
                </validation-provider>
                <validation-provider
                  v-if="mandatoryFilters === 'preparationSlotsSearchPeriod'"
                  class="width-100"
                  rules="min_value:1|integer|required"
                  name="preparation slots search period"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    v-model="formRule.preparationSlotsSearchPeriod"
                    :label="$t('orderWorkflow.preparationSlotsSearchPeriod')"
                    type="number"
                    :min="1"
                    :error-messages="errors"
                    required
                    :suffix="$t('orderWorkflow.days')"
                    :disabled="!modificationEnabled"
                  >
                    <template v-slot:append-outer>
                      <v-tooltip v-model="showSearchPeriodTooltip" top>
                        <template v-slot:activator="{ attrs }">
                          <v-btn
                            class="mt-1"
                            :disabled="!modificationEnabled"
                            x-small
                            icon
                            v-bind="attrs"
                            @click="showSearchPeriodTooltip = !showSearchPeriodTooltip"
                          >
                            <v-icon>mdi-information-outline</v-icon>
                          </v-btn>
                        </template>
                        <span>{{ $t('orderWorkflow.includingClosingHours') }}</span>
                      </v-tooltip>
                    </template>
                  </v-text-field>
                </validation-provider>
                <validation-provider
                  v-if="mandatoryFilters === 'maxPassesNumber'"
                  class="width-100"
                  rules="min_value:1|integer|required"
                  name="max passes number"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    v-model="formRule.maxPassesNumber"
                    :label="$t('orderWorkflow.maxPassesNumber')"
                    type="number"
                    :min="1"
                    :error-messages="errors"
                    required
                    :disabled="!modificationEnabled || formRule.forcePickupLocationAsSource"
                  ></v-text-field>
                </validation-provider>
                <validation-provider
                  v-if="mandatoryFilters === 'maxLocationsTested'"
                  class="width-100"
                  rules="min_value:1|integer|required"
                  name="max locations tested"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    v-model="formRule.maxLocationsTested"
                    :label="$t('orderWorkflow.maxLocationsTested')"
                    type="number"
                    :error-messages="errors"
                    required
                    :disabled="!modificationEnabled"
                  ></v-text-field>
                </validation-provider>
                <v-autocomplete
                  v-if="mandatoryFilters === 'orchestrationPriorities'"
                  v-model="formRule.orchestrationPriorities"
                  :items="orchestrationPriorities"
                  item-text="text"
                  :label="$t('orchestrationRule.orchestrationPriority')"
                  required
                  multiple
                  :disabled="!modificationEnabled"
                ></v-autocomplete>
                <v-switch
                  v-if="mandatoryFilters === 'itemsAvailabilityChecking'"
                  v-model="formRule.itemsAvailabilityChecking"
                  :label="$t('orderWorkflow.itemsAvailabilityChecking')"
                  :disabled="!modificationEnabled"
                />
                <v-switch
                  style="text-transform: none"
                  v-if="mandatoryFilters === 'authorizeBalance'"
                  v-model="formRule.authorizeBalance"
                  :messages="$t('orderWorkflow.authorizeBalanceHint')"
                  :disabled="!modificationEnabled"
                >
                  hide-details
                  <template v-slot:label>
                    <span style="text-transform: uppercase">{{ $t('orderWorkflow.authorizeBalance') }}</span>
                  </template>
                </v-switch>
                <v-switch
                  style="text-transform: none"
                  v-if="mandatoryFilters === 'totalEligibilityChecking'"
                  v-model="formRule.totalEligibilityChecking"
                  :messages="$t('orderWorkflow.totalEligibilityChecking')"
                  :disabled="!modificationEnabled"
                >
                  <template v-slot:label>
                    <span style="text-transform: uppercase">{{ $t('orderWorkflow.noSplit') }}</span>
                  </template>
                </v-switch>
                <v-switch
                  style="text-transform: none"
                  v-if="mandatoryFilters === 'authorizeSplitAtOrchestration'"
                  v-model="formRule.authorizeSplitAtOrchestration"
                  :messages="$t('orderWorkflow.authorizeSplitAtOrchestration')"
                  :disabled="!modificationEnabled"
                >
                  <template v-slot:label>
                    <span style="text-transform: uppercase">{{ $t('orderWorkflow.authorizeSplit') }}</span>
                  </template>
                </v-switch>
              </v-row>
              <!-- facultative filters -->
              <v-row
                v-for="(filter, index) in formRule.filters"
                :key="filter.key"
                align="center"
                v-show="modificationEnabled || showFilters"
              >
                <v-col cols="12" md="5">
                  <v-select
                    v-model="filter.key"
                    :items="unusedFilterOptions"
                    :label="getLabel(filter.key, 'Type of filter')"
                    :disabled="!modificationEnabled || unusedFilterOptions.length === 0"
                    @change="filter.value = ''"
                  ></v-select>
                </v-col>

                <v-col cols="12" md="5">
                  <validation-provider
                    rules="required"
                    name="country"
                    v-slot="{ errors }"
                    v-if="filter.key === 'country'"
                  >
                    <v-select
                      v-model="filter.value"
                      :items="countries"
                      label="Select country"
                      multiple
                      required
                      :disabled="!modificationEnabled"
                      :error-messages="errors"
                      :key="filter.key"
                    ></v-select>
                  </validation-provider>
                  <validation-provider
                    rules="min_value:0|required"
                    name="radius"
                    v-slot="{ errors }"
                    v-if="filter.key === 'radius'"
                  >
                    <v-text-field
                      v-model="filter.value"
                      type="number"
                      :error-messages="errors"
                      label="value"
                      required
                      :suffix="$t('orderWorkflow.kilometers')"
                      :disabled="!modificationEnabled"
                      :key="filter.key"
                    ></v-text-field>
                  </validation-provider>
                </v-col>
                <v-col v-if="modificationEnabled" cols="12" md="2">
                  <v-icon class="mr-2" @click="removeFilter(index)">mdi-close</v-icon>
                </v-col>
              </v-row>
            </v-container>
            <!-- bottom form buttons -->
            <v-card-actions class="justify-center">
              <v-btn
                small
                v-if="!modificationEnabled"
                class="ma-2"
                color="primary"
                outlined
                @click="activateModifications"
              >
                {{ $t('orderWorkflow.modify') }}
              </v-btn>
              <v-btn small v-else class="ma-2" color="primary" outlined @click="validate">
                {{ $t('orderWorkflow.valid') }}
              </v-btn>
              <v-btn
                small
                v-if="!createNew"
                class="ma-2"
                color="primary"
                outlined
                @click="$emit('rule-form-deleted', formRule.id)"
              >
                {{ $t('orderWorkflow.delete') }}
              </v-btn>
              <v-btn small v-else class="ma-2" color="primary" outlined @click="$emit('rule-form-cancelled')">
                {{ $t('orderWorkflow.cancel') }}
              </v-btn>
            </v-card-actions>
          </v-form>
        </validation-observer>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
  import { extend, ValidationObserver, ValidationProvider } from 'vee-validate'
  import { integer, numeric } from 'vee-validate/dist/rules'
  import { mapState } from 'vuex'

  extend('integer', {
    ...integer,
    message: 'floating point numbers are not allowed',
  })
  extend('numeric', { ...numeric })

  export default {
    name: 'orderWorkflowForm',
    components: {
      'validation-provider': ValidationProvider,
      'validation-observer': ValidationObserver,
    },
    data() {
      return {
        formRule: {
          name: undefined,
          stockSearchPriority: 'shop',
          filters: [],
          itemsAvailabilityChecking: false,
          authorizeBalance: false,
          maximumResponseTime: 1,
          preparationSlotsSearchPeriod: 1,
          maxPassesNumber: 1,
          maxLocationsTested: 1,
          totalEligibilityChecking: false,
          authorizeSplitAtOrchestration: false,
          forcePickupLocationAsSource: false,
          excludePickupLocationAsSource: false,
          forcedLocations: [],
          orchestrationPriorities: ['distance'],
          predefinedLocationListId: null,
        },
        filterOptions: {
          shop: {
            mandatory: [
              'orchestrationPriorities',
              'maxPassesNumber',
              'maximumResponseTime',
              'preparationSlotsSearchPeriod',
              /*'maxLocationsTested'*/ 'authorizeBalance',
              'itemsAvailabilityChecking',
              /*'totalEligibilityChecking',*/ 'forcePickupLocationAsSource',
              'authorizeSplitAtOrchestration',
            ],
            facultative: [
              /*'radius', 'country'*/
            ],
          },
          warehouse: {
            mandatory: [
              'orchestrationPriorities',
              'maxPassesNumber',
              /*'maxLocationsTested',*/ 'itemsAvailabilityChecking' /*'totalEligibilityChecking',*/,
              'authorizeSplitAtOrchestration',
            ],
            facultative: [
              /*'radius', 'country'*/
            ],
          },
          customized_location_list: {
            mandatory: [
              'orchestrationPriorities',
              'forcedLocations',
              'maximumResponseTime',
              'preparationSlotsSearchPeriod',
              'maxPassesNumber',
              /*'maxLocationsTested'*/ 'authorizeBalance',
              'itemsAvailabilityChecking' /*'totalEligibilityChecking',*/,
              'authorizeSplitAtOrchestration',
            ],
            facultative: [
              /*'radius', 'country'*/
            ],
          },
          predefined_location_list: {
            mandatory: [
              'orchestrationPriorities',
              'predefinedLocationList',
              'maximumResponseTime',
              'preparationSlotsSearchPeriod',
              'maxPassesNumber',
              'authorizeBalance',
              'itemsAvailabilityChecking',
              'authorizeSplitAtOrchestration',
            ],
            facultative: [],
          },
          from_data: {
            mandatory: [
              'maximumResponseTime',
              'preparationSlotsSearchPeriod',
              /*'maxLocationsTested'*/ 'authorizeBalance',
              'itemsAvailabilityChecking',
              /*'totalEligibilityChecking',*/
              'authorizeSplitAtOrchestration',
            ],
            facultative: [
              /*'radius', 'country'*/
            ],
          },
          all: {
            mandatory: [
              'orchestrationPriorities',
              'maxPassesNumber',
              'maximumResponseTime',
              'preparationSlotsSearchPeriod',
              /*'maxLocationsTested'*/ 'authorizeBalance',
              'itemsAvailabilityChecking',
              /*'totalEligibilityChecking',*/ 'forcePickupLocationAsSource',
              'authorizeSplitAtOrchestration',
            ],
            facultative: [
              /*'radius', 'country'*/
            ],
          },
        },
        stockSearchPriorities: [
          { text: this.$t('orderWorkflow.allStockPoints'), value: 'all' },
          { text: this.$t('orderWorkflow.warehouse'), value: 'warehouse' },
          { text: this.$t('orderWorkflow.shop'), value: 'shop' },
          { text: this.$t('orderWorkflow.customizedLocationList'), value: 'customized_location_list' },
          { text: this.$t('orderWorkflow.predefinedLocationList'), value: 'predefined_location_list' },
          { text: this.$t('orderWorkflow.fromData'), value: 'from_data' },
        ],
        // TODO: get countries by API
        countries: [
          { text: this.$t('orderWorkflow.France'), value: 'France' },
          { text: this.$t('orderWorkflow.Germany'), value: 'Germany' },
          { text: this.$t('orderWorkflow.Spain'), value: 'Spain' },
          { text: this.$t('orderWorkflow.Italy'), value: 'Italy' },
        ],
        showFilters: false,
        modificationEnabled: false,
        minimized: !this.createNew,
        orchestrationPriorities: [
          { text: this.$t('orchestrationRule.distance'), value: 'distance' },
          { text: this.$t('orchestrationRule.scoring'), value: 'scoring' },
        ],
        showSearchPeriodTooltip: false,
        showMaximumResponseTimeTooltip: false,
        showSearchPeriodTooltipInterval: undefined,
        showMaximumResponseTimeTooltipInterval: undefined,
      }
    },
    props: {
      rule: {
        type: Object,
        required: false,
        default: undefined,
      },
      createNew: {
        type: Boolean,
        required: false,
        default: false,
      },
      locations: {
        type: Array,
        required: false,
        default: () => {
          return []
        },
      },
      lists: {
        type: Array,
        required: false,
        default: () => {
          return []
        },
      },
      listsLoading: {
        type: Boolean,
        required: false,
        default: false,
      },
      restoreContext: {
        type: Object,
        required: false,
        default: undefined,
      },
    },
    mounted() {
      if (this.createNew) {
        this.modificationEnabled = true
      }
      this.fillFormRule()
      if (this.restoreContext) {
        this.formRule = { ...this.formRule, ...this.restoreContext.formRule }
        this.modificationEnabled = true
        this.minimized = false
        if (this.restoreContext.createdListId) {
          this.formRule.predefinedLocationListId = this.restoreContext.createdListId
        }
      }
    },
    methods: {
      addFilter: function () {
        if (!this.formRule.filters.some((filter) => filter.key === '' && filter.value === '')) {
          if (this.unusedFilterOptions.length !== 0) {
            this.showFilters = true
            this.formRule.filters.push({ key: '', value: '' })
          }
        }
      },
      removeFilter: function (index) {
        this.formRule.filters.splice(index, 1)
      },
      getLabel: function (label, defaultLabel) {
        return label === '' ? defaultLabel : this.$t('orderWorkflow.' + label)
      },
      validate: function () {
        this.$refs.form.validate().then((success) => {
          if (success) {
            this.modificationEnabled = false
            let builtRule = {
              in_modification: false,
              _id: this.formRule.id ? this.formRule.id : 'provisory_id_' + Date.now(),
              stock_search_priority: this.formRule.stockSearchPriority,
              name: this.formRule.name,
              filters: this.formRule.filters,
            }
            for (let mandatoryFilter of this.filterOptions[this.formRule.stockSearchPriority]['mandatory']) {
              if (mandatoryFilter === 'preparationSlotsSearchPeriod') {
                builtRule[this.convertCamelIntoSnakeCase(mandatoryFilter)] = this.formRule[mandatoryFilter] * 86400
              } else if (mandatoryFilter === 'predefinedLocationList') {
                builtRule['predefined_location_list_id'] = this.formRule.predefinedLocationListId
              } else {
                builtRule[this.convertCamelIntoSnakeCase(mandatoryFilter)] = this.formRule[mandatoryFilter]
              }
            }
            if (this.formRule.stockSearchPriority === 'from_data') {
              builtRule.max_passes_number = 1
            }
            this.$emit('rule-form-validated', builtRule)
          }
        })
      },
      activateModifications: function () {
        this.modificationEnabled = true
        this.$emit('rule-form-enabled')
      },
      onCreateList: function ({ mode }) {
        // The 'new' literal is a stable restore key for the single in-progress
        // rule form. It must stay a constant (not a generated id) so the parent
        // can match it after the sessionStorage round-trip. This is safe because
        // the UI only ever renders one "new rule" form at a time (addingRule).
        this.$emit('prepare-list-creation', {
          mode,
          rule: {
            key: this.formRule.id || 'new',
            formRule: { ...this.formRule },
          },
        })
      },
      fillFormRule: function () {
        if (this.rule != undefined) {
          this.formRule.id = this.rule._id
          this.formRule.stockSearchPriority = this.rule.stock_search_priority
          this.formRule.maximumResponseTime = this.rule.maximum_response_time
          this.formRule.maxPassesNumber = this.rule.max_passes_number ? this.rule.max_passes_number : 1
          this.formRule.maxLocationsTested = this.rule.max_locations_tested
          this.formRule.preparationSlotsSearchPeriod = this.rule.preparation_slots_search_period
            ? this.rule.preparation_slots_search_period / 86400
            : 1
          this.formRule.name = this.rule.name
          this.formRule.forcedLocations = this.rule.forced_locations ? this.rule.forced_locations : []
          this.formRule.predefinedLocationListId = this.rule.predefined_location_list_id || null
          this.formRule.orchestrationPriorities = this.rule.orchestration_priorities
            ? this.rule.orchestration_priorities
            : ['distance']
          /*the following fields are boolean, therefore because there are no validation on v-switches
          so we set them to false by default to avoid having undefined as value*/
          this.formRule.authorizeBalance =
            this.rule.authorize_balance != undefined ? this.rule.authorize_balance : false
          this.formRule.itemsAvailabilityChecking =
            this.rule.items_availability_checking != undefined ? this.rule.items_availability_checking : true
          this.formRule.totalEligibilityChecking =
            this.rule.total_eligibility_checking != undefined ? this.rule.total_eligibility_checking : false
          this.formRule.authorizeSplitAtOrchestration =
            this.rule.authorize_split_at_orchestration != undefined ? this.rule.authorize_split_at_orchestration : false
          this.formRule.forcePickupLocationAsSource = this.rule.force_pickup_location_as_source
            ? this.rule.force_pickup_location_as_source
            : false
          this.formRule.excludePickupLocationAsSource = this.rule.exclude_pickup_location_as_source
            ? this.rule.exclude_pickup_location_as_source
            : false
          for (let filter of this.rule.filters) {
            this.formRule.filters.push({ key: filter['key'], value: filter['value'] })
          }
        } else {
          this.formRule.itemsAvailabilityChecking = true
          this.formRule.totalEligibilityChecking = true
          this.formRule.authorizeSplitAtOrchestration = true
        }
      },
      forceSource: function () {
        if (this.formRule.forcePickupLocationAsSource) {
          this.formRule.excludePickupLocationAsSource = false
          this.formRule.maxPassesNumber = 1
        }
      },
      excludePickup: function () {
        if (this.formRule.excludePickupLocationAsSource) {
          this.formRule.forcePickupLocationAsSource = false
        }
      },
      convertCamelIntoSnakeCase(textInCamelCase) {
        return textInCamelCase
          .split(/(?=[A-Z])/)
          .join('_')
          .toLowerCase()
      },
    },
    computed: {
      ...mapState(['currentGroup']),
      deliveryTypeFilterOption: function () {
        let stockSearchPriority = this.formRule.stockSearchPriority
        let filterOptions = this.filterOptions[stockSearchPriority]['facultative']
        let deliveryTypeFilterOption = []
        for (let filterOption of filterOptions) {
          deliveryTypeFilterOption.push({ text: this.$t('orderWorkflow.' + filterOption), value: filterOption })
        }
        return deliveryTypeFilterOption
      },
      unusedFilterOptions: function () {
        let usedFilters = []
        for (let filter of this.formRule.filters) {
          if (filter.key.trim() != '') {
            usedFilters.push(filter.key)
          }
        }
        return this.deliveryTypeFilterOption.filter((filterOption) => !usedFilters.includes(filterOption.value))
      },
      stockPriorityLocations: function () {
        return this.locations.map((location) => location.location_id)
      },
    },
    watch: {
      'formRule.stockSearchPriority': function (val) {
        if (val === 'customized_location_list') {
          this.$emit('get-locations')
        }
        if (val !== 'predefined_location_list') {
          this.formRule.predefinedLocationListId = null
        }
        if (val === 'shop' && this.formRule.forcePickupLocationAsSource) {
          this.formRule.maxPassesNumber = 1
        }
        if (
          !this.filterOptions[this.formRule.stockSearchPriority]['mandatory'].includes('forcePickupLocationAsSource')
        ) {
          this.formRule.forcePickupLocationAsSource = false
        }
      },
      showSearchPeriodTooltip(value) {
        if (value === true) {
          this.showSearchPeriodTooltipInterval = setInterval(() => {
            this.showSearchPeriodTooltip = false
          }, 1000)
        } else {
          clearInterval(this.showSearchPeriodTooltipInterval)
        }
      },
      showMaximumResponseTimeTooltip(value) {
        if (value === true) {
          this.showMaximumResponseTimeTooltipInterval = setInterval(() => {
            this.showMaximumResponseTimeTooltip = false
          }, 1000)
        } else {
          clearInterval(this.showMaximumResponseTimeTooltipInterval)
        }
      },
    },
  }
</script>
<style scoped>
  .width-100 {
    width: 100%;
  }
</style>
